export default __webpack_public_path__ + "static/media/etown-logo.120840f7.png";